import { createSlice } from '@reduxjs/toolkit';
import { getRevenueChartsData, RevenueDataItem } from './thunks';

interface DashboardEcommerceState {
  revenueData: RevenueDataItem[];
  loading: boolean;
  error: string | null;
}

const initialState: DashboardEcommerceState = {
  revenueData: [],
  loading: false,
  error: null
};

const dashboardEcommerceSlice = createSlice({
  name: 'dashboardEcommerce',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRevenueChartsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRevenueChartsData.fulfilled, (state, action) => {
        state.loading = false;
        state.revenueData = action.payload;
      })
      .addCase(getRevenueChartsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch revenue data';
      });
  }
});

export default dashboardEcommerceSlice.reducer;